import axiosClient from "./axiosClient";

export const insertAbsences = async (classroomId, date, absences) => {
  const response = await axiosClient.post("/Manager/Absence/AddAbsence/" + classroomId + "/" + date, { absences });
  return response.data;
};

export const getAbsencesOfDay = async (date) => {
  const response = await axiosClient.get("/Manager/Absence/GetDayAbsences/" + date);
  return response.data;
};

export const RemoveAbsence = async (studentId, date) => {
  const response = await axiosClient.delete("/Manager/Absence/RemoveAbsence/" + studentId + "/" + date);
  return response.data;
};